import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../components/login/router/index.js'
import Dashboard from '../components/dashboard/router/index.js'
import Register from '../components/register/router/index.js'
import ForgotPassword from '../components/forgotpassword/router/index.js'
import CompaniesRoute from '../components/companies/router/index.js'
import SupplierRoute from '../components/suppliers/router/index.js'
import ResourcesRoute from '../components/resources/router/index.js'
import ContactRoute from '../components/contacts/router/index.js'
import TaskRoute from '../components/task/router/index.js'
import AgenciesRoute from '../components/agencies/router/index.js'
import ItineraryRoute from '../components/itinerary/router/index.js'
import EmailRoute from '../components/emails/router/index.js'
import UsersRoute from '../components/users/router/index.js'
import UserActivityRoute from '../components/useractivity/router/index.js'
import AiAssistantHistoryRoute from '../components/ai-assistant-history/router/index.js'
import AiUsageRoute from '../components/ai-usage/router/index.js'

// My StagI Routes
import LeadRoute from "../modules/admin/leads/route"
import QuoteRoute from "../modules/admin/quotes/route"
import QuotesListRoute from "../components/quotes/router/index.js"
import PackageRoute from "../modules/admin/packages/route"
import EventRoute from "../modules/admin/events/route"
import SettingsRoute from "../modules/admin/settings/route"
import ReportsRoute from "../modules/admin/reports/route"
import AgencySettingsRoute from "../modules/agency/settings/route"

import store from '../data/vuex'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        ...Login,
        ...Dashboard,
        ...Register,
        ...ForgotPassword,
        ...CompaniesRoute,
        ...SupplierRoute,
        ...ResourcesRoute,
        ...ContactRoute,
        ...TaskRoute,
        ...AgenciesRoute,
        ...ItineraryRoute,
        ...EmailRoute,
        ...UsersRoute,
        ...UserActivityRoute,
        ...AiAssistantHistoryRoute,
        ...AiUsageRoute,
        ...LeadRoute,
        ...QuoteRoute,
        ...QuotesListRoute,
        ...PackageRoute,
        ...EventRoute,
        ...SettingsRoute,
        ...ReportsRoute,
        ...AgencySettingsRoute,
    ]
});

// Opening a link to a record (meta.company_record) that belongs to another company switches the
// selected company to it before the page loads, so the page and sidebar match the record.
router.beforeEach(async (to, from, next) => {
    const record = to.meta && to.meta.company_record
    const id = record && to.params[record.param]
    if (!id || !store.getters['auth/get_token']) return next()

    try {
        const { data } = await Vue.axios.get(`admin/companies/get_record_company/${record.type}/${id}`)
        const company = data && data.response && data.data
        const selected = store.getters['auth/get_selected_company'] || {}
        if (company && company.id !== selected.id) {
            await store.dispatch('auth/set_selected_company', company)
            Vue.$toast.info(`Switched company to ${company.company_name}`)
        }
    } catch (e) {
        console.error(e)
    }
    next()
})

export default router